module.exports = "https://www.gc-qa.gnp.com.mx/f71eeb1fc886ca42a3ca9f1609aec737.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/reparacion/03.png
// module id = 1058
// module chunks = 0 1